import React, { useEffect, useState, useRef } from 'react';
import { motion } from 'framer-motion';
import { AnimatedCounter } from './AnimatedCounter';
import { supabase } from '../../lib/supabaseClient';
const FALLBACK_BASE = 847304;
export const LiveScanTicker = () => {
  const [scanCount, setScanCount] = useState<number>(FALLBACK_BASE);
  const [dbLoaded, setDbLoaded] = useState(false);
  const fallbackIntervalRef = useRef<ReturnType<typeof setInterval> | null>(null);
  // Try to fetch real count from database
  useEffect(() => {
    let cancelled = false;
    const fetchLiveCount = async () => {
      try {
        // Get today's completed scans count
        const todayStart = new Date();
        todayStart.setHours(0, 0, 0, 0);
        const {
          count,
          error
        } = await supabase.from('scans').select('*', {
          count: 'exact',
          head: true
        }).eq('status', 'completed').gte('created_at', todayStart.toISOString());
        if (!cancelled && !error && typeof count === 'number' && Number.isFinite(count)) {
          // Add the count on top of the base to keep numbers impressive
          const total = FALLBACK_BASE + count;
          setScanCount(total);
          setDbLoaded(true);
        }
      } catch {
        // DB unavailable — fallback will handle it
      }
    };
    fetchLiveCount();
    // Re-fetch every 30 seconds for real-time feel
    const refreshInterval = setInterval(fetchLiveCount, 30000);
    return () => {
      cancelled = true;
      clearInterval(refreshInterval);
    };
  }, []);
  // Fallback: increment by 1-3 every 3-6 seconds to simulate live activity
  useEffect(() => {
    // Always run the simulated increment for a live feel
    const startFallback = () => {
      if (fallbackIntervalRef.current) return;
      const tick = () => {
        const increment = Math.floor(Math.random() * 3) + 1;
        setScanCount(prev => {
          const safe = Number.isFinite(prev) ? prev : FALLBACK_BASE;
          return safe + increment;
        });
        // Random interval between 3-6 seconds
        const nextDelay = 3000 + Math.floor(Math.random() * 3000);
        fallbackIntervalRef.current = setTimeout(tick, nextDelay) as unknown as ReturnType<typeof setInterval>;
      };
      const initialDelay = 3000 + Math.floor(Math.random() * 3000);
      fallbackIntervalRef.current = setTimeout(tick, initialDelay) as unknown as ReturnType<typeof setInterval>;
    };
    startFallback();
    return () => {
      if (fallbackIntervalRef.current) {
        clearTimeout(fallbackIntervalRef.current as unknown as number);
        fallbackIntervalRef.current = null;
      }
    };
  }, []);
  return <div className="bg-[#FF0000] text-[#FFD700] py-2 px-4 overflow-hidden relative z-50" data-id="element-2864">
      <div className="max-w-7xl mx-auto flex items-center justify-center gap-3 font-bold uppercase tracking-widest text-sm md:text-base" data-id="element-2865">
        <motion.div animate={{
        opacity: [1, 0.5, 1]
      }} transition={{
        duration: 1.5,
        repeat: Infinity
      }} className="w-3 h-3 bg-[#FFD700] rounded-full" data-id="element-2866" />
        <span data-id="element-2867">🚨 LIVE:</span>
        <div className="bg-black/20 px-2 rounded font-mono tabular-nums" data-id="element-2868">
          {scanCount.toLocaleString()}
        </div>
        <span data-id="element-2869">SCANS COMPLETED TODAY</span>
      </div>

      {/* Scan line effect overlay */}
      <motion.div className="absolute top-0 left-0 w-full h-full bg-gradient-to-r from-transparent via-white/20 to-transparent" animate={{
      x: ['-100%', '100%']
    }} transition={{
      duration: 3,
      repeat: Infinity,
      ease: 'linear'
    }} data-id="element-2870" />
    </div>;
};